import React, { PropsWithChildren } from "react"

import { Color } from "../../../constants/V2/color"
import LayoutHeader, { LayoutHeaderProps } from "../LayoutComponents/Header"
import LayoutSection, { CTAProps } from "../LayoutComponents/LayoutSection"
import MasonryGrid from "../LayoutComponents/MasonryGrid"

import { getAccentColor } from "@utils/V2/color"

type Props = PropsWithChildren<
  CTAProps & {
    id?: string
    primaryBackgroundColor: Color
    secondaryBackgroundColor?: Color
    heading?: LayoutHeaderProps
  }
>

const MasonryGridSection = ({
  id,
  heading,
  primaryBackgroundColor,
  secondaryBackgroundColor,
  ctaType,
  ctaColor,
  ctaText,
  ctaLink,
  trackingEvent,
  trackingEventKey,
  trackingEventValue,
  children,
  ...props
}: Props) => {
  return (
    <LayoutSection
      id={id}
      ctaType={ctaType}
      ctaText={ctaText}
      ctaLink={ctaLink}
      ctaColor={ctaColor}
      trackingEvent={trackingEvent}
      trackingEventKey={trackingEventKey}
      trackingEventValue={trackingEventValue}
      primaryBackgroundColor={primaryBackgroundColor}
      secondaryBackgroundColor={secondaryBackgroundColor}
      {...props}
    >
      {(heading?.superscriptText ||
        heading?.headingText ||
        heading?.headingBodyText) && (
        <LayoutHeader
          size={heading?.size || "large"}
          alignment={heading?.alignment || "center"}
          mobileAlignment={heading?.mobileAlignment}
          superscriptText={heading?.superscriptText}
          superscriptColor={
            heading?.superscriptColor || getAccentColor(primaryBackgroundColor)
          }
          headingText={heading?.headingText}
          headingTextColor={
            heading?.headingTextColor || getAccentColor(primaryBackgroundColor)
          }
          headingBodyText={heading?.headingBodyText}
          headingBodyColor={
            heading?.headingBodyColor || getAccentColor(primaryBackgroundColor)
          }
          highlightedText={heading?.highlightedText}
          highlightColor={heading?.highlightColor}
          callout={heading?.callout}
        />
      )}

      <MasonryGrid>{children}</MasonryGrid>
    </LayoutSection>
  )
}

export default MasonryGridSection
